<template>
  <div>
    <div class="block block--top-md block--bottom-sm">
      <div class="block__content">
        <div class="junction white-container--with-padding white-container--with-big-padding">
          <img
            :src="require('~/images/icon-question.svg')"
            width="54"
            height="68"
            :alt="$t('infoPanel.heading')"
          >
          <div class="junction__content">
            <div class="junction__text">
              <h3
                class="h3"
                v-html="$t('infoPanel.heading')"
              />
              <p v-html="$t('infoPanel.text')" />
            </div>
            <nav class="junction__nav">
              <a
                v-if="$te('infoPanel.href_1') && !isRsOrNl"
                :href="$t('infoPanel.href_1')"
                target="_blank"
                rel="noreferrer noopener"
                class="el-button el-button--warning"
              >
                {{ $t("infoPanel.link_1") }}
              </a>
              <Button
                :to="PATH_INVOICE_TYPES"
                class="el-button el-button--default"
              >
                {{ $t("infoPanel.link_2") }}
              </Button>
              <Button
                :to="PATH_FAQ"
                class="el-button el-button--default"
              >
                {{ $t("infoPanel.link_3") }}
              </Button>
              <Button
                :to="PATH_HELP"
                class="el-button el-button--default"
              >
                {{ $t("infoPanel.link_4") }}
              </Button>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  PATH_INVOICE_TYPES, PATH_FAQ, PATH_HELP,
} from '~/router';

export default {
  name: 'InfoPanel',
  data() {
    return {
      PATH_INVOICE_TYPES,
      PATH_FAQ,
      PATH_HELP,
    };
  },
  computed: {
    isRsOrNl() {
      return ['rs', 'nl'].includes(this.$i18n.locale);
    },
  },
};
</script>
